import { Box,/*useTheme,*/TextField,Button, Grid,Paper, Typography, Dialog, DialogTitle, DialogContent, DialogActions, InputAdornment, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
//import { useNavigate } from "react-router-dom";
import useAuth from "../../../../auth/useAuth";
import Header from "../../../../components/Header";
import { useRef, useState } from "react";
import { useFormik } from "formik";
//import { tokens } from "../../../../theme";
import { getBoxPaymentsSummaryRoute, getBoxPaymentsDetailRoute, newPaymentRoute, reportarNoVisita } from "../../../../config";
import FatalError from "../../../global/FatalError";
import Loading from "../../../global/Loading";
import swal from "sweetalert";
import * as yup from "yup";
import ReactSignatureCanvas from "react-signature-canvas";
import UploadImage from "../../../../components/images/UploadImage";
import UploadImageDialog from "../../../dialogs/delivery/UploadImageDialog";

const IngresoEfectivo = () => {
  //const theme = useTheme();
  //const colors = tokens(theme.palette.mode)
  const auth = useAuth();
  const token = auth.globals.token
  //const {data,loading,error} = useFetch2(`${url}/api/clients`,token)

  //const navigate = useNavigate();

  const [ loadingRequest, setLoadingRequest ] = useState(false)
  const [ errorRequest, setErrorRequest ] = useState(null)


  const [signatureOpen, setSignatureOpen] = useState(false);
  const [signatureData, setSignatureData] = useState('');
  const sigCanvasRef = useRef({});

  const [images, setImages] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [showUploadImageDialog, setShowUploadImageDialog] = useState(false);


  const handleOpenSignature = () => {
    setSignatureOpen(true);
  };

  const handleSaveSignature = () => {
    if (sigCanvasRef.current.isEmpty()) {
      setSignatureData('');
      setSignatureOpen(false);
    }else{
      setSignatureData(sigCanvasRef.current.getTrimmedCanvas().toDataURL('image/png'));
      setSignatureOpen(false);
    }
    // Aquí puedes actualizar el estado o el formulario con la firma en base64
  };


  const handleClearSignature = () => {
    sigCanvasRef.current.clear();
  };


  const statusOptions = [
    { id: 1, name: 'Delivery' },
    { id: 2, name: 'Pickup' },
    { id: 3, name: 'Tránsito a bodega USA' },
    { id: 5, name: 'Tránsito a Aduana' },
    { id: 6, name: 'Trámite en Aduana' },
    { id: 7, name: 'Bodega país destino' },
    { id: 8, name: 'Trancito para entrega' },
    { id: 9, name: 'Entregada' },
  ];

  const getStatusName = (statusId) => {
    const status = statusOptions.find(option => option.id === statusId);
    return status ? status.name : 'Estado desconocido';
  };

  const getBoxSummary = async(id_box) =>{
    if(id_box && id_box !== "" ){
      try{
        setLoadingRequest(true)
        //console.log('id_box',id_box)
        let res = await fetch(getBoxPaymentsSummaryRoute(id_box), {
          method: "GET",
          headers: {
            //"Access-Control-Allow-Origin": "*",
            "Content-Type": "application/json",
            "Accept":"application/json",
            "Authorization": `Bearer ${token}`
            //"x-access-token": token,
          },
          //cors: 'no-cors'
        })
        let data = await res.json()
        //console.log('sumary',data)
        if(res.ok){
          setRecord(data[0])
        }else{
          //console.log('res',res)
          if(res.status === 404){
            mostrarErrorRequest("Registro no encontrado")
            setRecord(null)
            setPaymentDetail([])
          }
          if(res.status === 401||res.status === 403){
            mostrarErrorRequest("No tiene autorización o su sesión ha expirado")
          }
        }
        setLoadingRequest(false)
        return data;
      }catch(errorRequest){
        setLoadingRequest(false)
        setErrorRequest(errorRequest)
      }
    }
  }

  const newPayment = async(body) =>{
    try{
      setLoadingRequest(true)
      const paymentPayload = {
        "id_box":record.id.toString(),
        "box_status" : record.status.toString(),
        "payment_signature" : signatureData,
        "comment" : body.comment,
        "destination_user" : null,
        "detail" : [
          { payment_method: "Efectivo", payment: body.cash },
          { payment_method: "Zelle", payment: body.card, ...(body.card_ref && { transaction_number: body.card_ref }) },
          { payment_method: "Cheque", payment: body.check },
          { payment_method: "Tarjeta de Credito", payment: body.credit_card, ...(body.credit_card_ref && { transaction_number: body.credit_card_ref }) },
        ].filter(d => parseFloat(d.payment) > 0)
      }
      console.log('json pago', paymentPayload)
      let res = await fetch(newPaymentRoute(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept":"application/json",
          "Authorization": `Bearer ${token}`
        },
        body: JSON.stringify(paymentPayload),
      })
      let data = await res.json()
      console.log('resultados nuevo delivery: ',data)
      if(res.ok){
        alertSucess("Pago registrado con éxito",data.message)
        await getBoxSummary(searchFormik.values.recordId)
        return true;
      }else{
        if(res.status === 401||res.status === 403){
          mostrarErrorRequest("No tiene autorización o su sesión ha expirado")
        }
        mostrarErrorRequest(data.detail)
        setErrorRequest(data.detail)
        setLoadingRequest(false)
        return false;
      }
    }catch(errorRequest){
      setLoadingRequest(false)
      setErrorRequest(errorRequest)
      return false;
    }
  }

  const [record, setRecord] = useState(null);
  const [paymentDetail, setPaymentDetail] = useState([]);
  const [showReprogramarDialog, setShowReprogramarDialog] = useState(false);
  const [motivoReprogramar, setMotivoReprogramar] = useState('');
  const [loadingReprogramar, setLoadingReprogramar] = useState(false);

  const isPiloto = auth.globals.name_role?.toLowerCase().includes('driver');

  const handleReprogramar = async () => {
    if (!motivoReprogramar.trim()) return;
    try {
      setLoadingReprogramar(true);
      const res = await reportarNoVisita(token, record.id, motivoReprogramar.trim());
      const data = await res.json();
      if (res.ok) {
        alertSucess('Solicitud enviada', 'El administrador revisará la reprogramación');
        setShowReprogramarDialog(false);
        setMotivoReprogramar('');
      } else {
        mostrarErrorRequest(data.detail || 'Error al enviar la solicitud');
      }
    } catch (e) {
      mostrarErrorRequest('Error inesperado al enviar la solicitud');
    } finally {
      setLoadingReprogramar(false);
    }
  };

  const getBoxPaymentDetail = async (id_box) => {
    try {
      let res = await fetch(getBoxPaymentsDetailRoute(id_box), {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "Authorization": `Bearer ${token}`
        },
      })
      if (res.ok) {
        let data = await res.json()
        setPaymentDetail(data)
      } else {
        setPaymentDetail([])
      }
    } catch {
      setPaymentDetail([])
    }
  }

  const searchFormik = useFormik({
      initialValues: {
          recordId: '',
      },
      onSubmit: (values) => {
        //console.log(values)
        getBoxSummary(values.recordId)
      },
  });

  const paymentSchema = yup.object().shape({
    cash: yup.number().required('* Valor Requerido').min(0.00, 'El valor debe ser mayor o igual a 0').typeError('Debe ser un número válido'),
    card: yup.number().required('* Valor Requerido').min(0.00, 'El valor debe ser mayor o igual a 0').typeError('Debe ser un número válido'),
    card_ref: yup.string(),
    check: yup.number().required('* Valor Requerido').min(0.00, 'El valor debe ser mayor o igual a 0').typeError('Debe ser un número válido'),
    credit_card: yup.number().required('* Valor Requerido').min(0.00, 'El valor debe ser mayor o igual a 0').typeError('Debe ser un número válido'),
    credit_card_ref: yup.string(),
  })

  const paymentFormik = useFormik({
      initialValues: {
          cash: '0',
          card: '0',
          card_ref: '',
          check: '0',
          credit_card: '0',
          credit_card_ref: '',
          comment: '',
      },
      validationSchema: paymentSchema, 
      onSubmit: async (values, { resetForm }) => {
        if (record.status === 2 && (!signatureData || signatureData === '')) {
          mostrarAlertRequest('Por favor, agregue una firma válida.');
          return;
        }
        if (((record.status === 1 && amountToCharge>0)||(record.status === 3)) && (parseInt(values.cash)===0) && (parseInt(values.card)===0) && (parseInt(values.check)===0) && (parseInt(values.credit_card)===0)) {
          mostrarAlertRequest('Por favor ingrese algún tipo de pago.');
          return;
        }
        const success = await newPayment(values);
        if (success) {
          resetForm();
          setSignatureData('');
        }
      },
  });


  const mostrarErrorRequest=(error)=>{
    if(error!=null){
      try{
        swal({
          title:"Error",
          text: "Resultado: "+error,
          icon: "error",
          button:"Aceptar"
        })
        if(error==="No tiene autorización o su sesión ha expirado"){
          auth.logout();
        }
      }catch(e){
        swal({
          title:"Error",
          text: "Error inesperado ",
          icon: "error",
          button:"Aceptar"
        })
      }
    }
    setErrorRequest(null)
  }

  const mostrarAlertRequest=(info)=>{
    if(info!=null){
      try{
        swal({
          title:"Alerta",
          text: info,
          icon: "warning",
          button:"Aceptar"
        })
        
      }catch(e){
        swal({
          title:"Error",
          text: "Error inesperado ",
          icon: "error",
          button:"Aceptar"
        })
      }
    }
  }

  const alertSucess=(text_title,text_content='')=>{    
    try{
      swal({
        title:text_title,
        text: text_content,
        icon: "success",
        button:"Aceptar"
      })
    }catch(e){
      swal({
        title:"Error inesperado",
        text: "Error inesperado ",
        icon: "error",
        button:"Aceptar"
      })
    }
    //navigate("/Dashboard")
  }

  const calculateAmountToCharge = () => {
    if (!record) return 0;
    //console.log(record)
    if (record.status === 1) {
      return record.delivery_cost - record.payed;
    } else if (record.status > 1) {
      return record.approximate_cost + record.insurance_cost + record.extra_payment - record.discount - record.payed;
    }
    return 0;
  };

  const amountToCharge = calculateAmountToCharge();
  const paperStyle = {
    backgroundColor: amountToCharge === 0 ? 'lightgreen' : 'lightcoral',
    padding: '15px',
    margin: '15px 0',
    textAlign: 'center'
  };

  if(loadingRequest)
  return(<Loading/>)

  if(errorRequest)
  return(<FatalError/>)


  return (
    <Box m="20px" marginBottom="64px">
      {/*<Box display="flex" justifyContent="space-between" alignItems="center">*/}
        <Header title="Ingreso Efectivo" subtitle="Ingreso Efectivo"/>
        <form onSubmit={searchFormik.handleSubmit}>
          <Box 
            sx={{ 
              display: 'flex', 
              justifyContent: 'left', 
              alignItems: 'center', 
              gap: 2,  // Espacio entre los elementos
              padding: 1 // Espacio alrededor del contenido
            }}
          >
            <TextField
              variant="filled"
              label="Código de caja"
              name="recordId"
              value={searchFormik.values.recordId}
              onChange={searchFormik.handleChange}
              size="small"
            />
            <Button type="submit" variant="contained" color="secondary">
              Buscar
            </Button>
          </Box>
        </form>

        {record && (
          <Paper style={paperStyle}>
            <Typography variant="h3">
              Cobrar: ${amountToCharge.toFixed(2)}
            </Typography>
          </Paper>
        )}

        {record && (
          <Paper style={{ margin: '15px 0', padding: '15px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1">Empresa: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' ' + record.company}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Cliente: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' ' + record.senders_name}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Teléfono: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' ' + record.senders_phone}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Dirección: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' ' + record.address}
                    </Typography>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1">Estado Caja: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' ' + getStatusName(record.status)}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Depósito: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' $' + record.delivery_cost}
                    </Typography>
                  </Box>
                </Typography>
              </Grid>
              <Grid item xs={12} sm={4}>
                <Typography variant="subtitle1">Precio de envío: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' $' + record.approximate_cost}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Precio del Seguro: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' $' + record.insurance_cost}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Costo Extra: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' $' + record.extra_payment}
                    </Typography>
                  </Box>
                </Typography>
                <Typography variant="subtitle1">Descuentos aplicados: 
                  <Box display="inline">
                    <Typography variant="subtitle1" display="inline" color="secondary">
                      {' $' + record.discount}
                    </Typography>
                  </Box>
                </Typography>
              </Grid>
            </Grid>
          </Paper>
        )}
        {record && (
          <Box sx={{ width: '100%', marginRight: 'auto', paddingBottom:'15px'}}>
            <form>
              <Grid container spacing={2} alignItems="center">
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle1">Pagado (USD)</Typography>
                    <TextField
                        label="Valor pagado"
                        name="payed"
                        value={record.payed}
                        disabled={true}
                        //onChange={paymentFormik.handleChange}
                        fullWidth
                        variant="filled"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle2">Total (USD)</Typography>
                    <TextField
                        label="Valor total"
                        name="cost"
                        value={record.approximate_cost + record.insurance_cost + record.extra_payment - record.discount}
                        disabled={true}
                        //onChange={paymentFormik.handleChange}
                        fullWidth
                        variant="filled"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                    />
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="subtitle3">Pendiente (USD)</Typography>
                    <TextField
                        label="Valor Pendiente"
                        name="debt"
                        value={record.approximate_cost + record.insurance_cost + record.extra_payment - record.discount - record.payed}
                        disabled={true}
                        //onChange={paymentFormik.handleChange}
                        fullWidth
                        variant="filled"
                        size="small"
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              $
                            </InputAdornment>
                          ),
                        }}
                    />
                </Grid>
              </Grid>
            </form>
          </Box>          
        )}
        {record && record.status < 5 &&(
          <form onSubmit={paymentFormik.handleSubmit}>
          <Box sx={{ width: { xs: '100%', sm: '50%', md: '35%' }, marginRight: 'auto'}}>
            <Grid container direction="column" spacing={2}>
              <Grid item container alignItems="center" spacing={2}>
                <Grid item style={{ width: '100px' }}>
                  <Typography variant="subtitle1">Efectivo</Typography>
                </Grid>
                <Grid item xs>
                  <TextField
                    label="Ingrese el valor"
                    name="cash"
                    value={paymentFormik.values.cash}
                    onChange={paymentFormik.handleChange}
                    fullWidth
                    variant="filled"
                    size="small"
                    onBlur={paymentFormik.handleBlur}
                    error={paymentFormik.touched.cash && Boolean(paymentFormik.errors.cash)} 
                    helperText={paymentFormik.touched.cash && paymentFormik.errors.cash}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container alignItems="center" spacing={2}>
                <Grid item style={{ width: '100px' }}>
                  <Typography variant="subtitle2">Zelle</Typography>
                </Grid>
                <Grid item xs>
                  <TextField
                    label="Ingrese el valor"
                    name="card"
                    value={paymentFormik.values.card}
                    onChange={paymentFormik.handleChange}
                    fullWidth
                    variant="filled"
                    size="small"
                    onBlur={paymentFormik.handleBlur}
                    error={paymentFormik.touched.card && Boolean(paymentFormik.errors.card)}
                    helperText={paymentFormik.touched.card && paymentFormik.errors.card}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              {parseFloat(paymentFormik.values.card) > 0 && (
                <Grid item container alignItems="center" spacing={2}>
                  <Grid item style={{ width: '100px' }} />
                  <Grid item xs>
                    <TextField
                      label="No. de Referencia"
                      name="card_ref"
                      value={paymentFormik.values.card_ref}
                      onChange={paymentFormik.handleChange}
                      fullWidth
                      variant="filled"
                      size="small"
                    />
                  </Grid>
                </Grid>
              )}
              <Grid item container alignItems="center" spacing={2}>
                <Grid item style={{ width: '100px' }}>
                  <Typography variant="subtitle3">Cheque</Typography>
                </Grid>
                <Grid item xs>
                  <TextField
                    label="Ingrese el valor"
                    name="check"
                    value={paymentFormik.values.check}
                    onChange={paymentFormik.handleChange}
                    fullWidth
                    variant="filled"
                    size="small"
                    onBlur={paymentFormik.handleBlur}
                    error={paymentFormik.touched.check && Boolean(paymentFormik.errors.check)}
                    helperText={paymentFormik.touched.check && paymentFormik.errors.check}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container alignItems="center" spacing={2}>
                <Grid item style={{ width: '100px' }}>
                  <Typography variant="subtitle3">Tarjeta de Crédito</Typography>
                </Grid>
                <Grid item xs>
                  <TextField
                    label="Ingrese el valor"
                    name="credit_card"
                    value={paymentFormik.values.credit_card}
                    onChange={paymentFormik.handleChange}
                    fullWidth
                    variant="filled"
                    size="small"
                    onBlur={paymentFormik.handleBlur}
                    error={paymentFormik.touched.credit_card && Boolean(paymentFormik.errors.credit_card)}
                    helperText={paymentFormik.touched.credit_card && paymentFormik.errors.credit_card}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          $
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
              {parseFloat(paymentFormik.values.credit_card) > 0 && (
                <Grid item container alignItems="center" spacing={2}>
                  <Grid item style={{ width: '100px' }} />
                  <Grid item xs>
                    <TextField
                      label="No. de Referencia"
                      name="credit_card_ref"
                      value={paymentFormik.values.credit_card_ref}
                      onChange={paymentFormik.handleChange}
                      fullWidth
                      variant="filled"
                      size="small"
                    />
                  </Grid>
                </Grid>
              )}
            </Grid>
            </Box>
            <Grid item style={{ paddingTop:'10px' }}>
                <Typography variant="subtitle1">Comentario</Typography>
                <TextField
                  label="Ingrese su comentario"
                  name="comment"
                  value={paymentFormik.values.comment}
                  onChange={paymentFormik.handleChange}
                  fullWidth
                  variant="filled"
                  size="small"
                />
            </Grid>
          <Grid container spacing={2} alignItems="center" sx={{ marginTop: '20px' }}>
            {(amountToCharge > 0 || (amountToCharge === 0 && record.status === 2) || (record.status === 1 && amountToCharge === 0 && record.delivery_cost === 0)) && (
              <Grid item>
                <Button type="submit" variant="contained" color="secondary">
                  Agregar Pago
                </Button>
              </Grid>
            )}

            {record.status === 2 && (
              <Grid item>
                <Button variant="contained" color="success" onClick={handleOpenSignature}>
                  Agregar Firma
                </Button>
              </Grid>
            )}

            {record.status >= 2 && record.status < 8 && (
              <Grid item>
                <UploadImage
                  images={images}
                  setImages={setImages}
                  setPreviews={setPreviews}
                  mostrarErrorRequest={mostrarErrorRequest}
                  setUploadImageDialog={setShowUploadImageDialog}
                  minimo={1}
                />
              </Grid>
            )}
            {isPiloto && (
              <Grid item>
                <Button
                  variant="outlined"
                  color="warning"
                  onClick={() => { setMotivoReprogramar(''); setShowReprogramarDialog(true); }}
                >
                  No pude visitar / Reprogramar
                </Button>
              </Grid>
            )}
          </Grid>

          <Dialog open={showReprogramarDialog} onClose={() => setShowReprogramarDialog(false)} maxWidth="sm" fullWidth>
            <DialogTitle>Solicitar reprogramación</DialogTitle>
            <DialogContent>
              <TextField
                label="Motivo"
                value={motivoReprogramar}
                onChange={e => setMotivoReprogramar(e.target.value)}
                fullWidth
                multiline
                rows={3}
                variant="filled"
                sx={{ mt: 1 }}
                required
              />
            </DialogContent>
            <DialogActions>
              <Button onClick={() => setShowReprogramarDialog(false)} color="inherit">Cancelar</Button>
              <Button
                variant="contained"
                color="warning"
                disabled={!motivoReprogramar.trim() || loadingReprogramar}
                onClick={handleReprogramar}
              >
                Confirmar
              </Button>
            </DialogActions>
          </Dialog>

            <UploadImageDialog openUploadImageDialog={showUploadImageDialog} boxId={record.id} auth={auth} token={token}
            onClose={() => setShowUploadImageDialog(false)} images={images} preview={previews} />

            <Dialog open={signatureOpen} onClose={() => setSignatureOpen(false)} fullWidth maxWidth="sm">
              <DialogContent >
                <Box 
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    border: '2px solid black',
                    borderRadius: '10px',
                    overflow: 'hidden',
                    margin: 'auto',
                    padding: '0px',
                    width: 'fit-content'
                  }}
                >
                  <ReactSignatureCanvas
                    penColor="black"
                    backgroundColor="#FFFFFF"
                    canvasProps={{ 
                      width: 500, 
                      height: 300, 
                      className: 'sigCanvas', 
                      style: { margin: '0px auto', display: 'block' }
                    }}
                    ref={sigCanvasRef}
                  />
                </Box>
                <DialogActions>
                  <Button onClick={handleSaveSignature} color="secondary">
                    Guardar Firma
                  </Button>
                  <Button onClick={handleClearSignature} color="warning">
                    Limpiar
                  </Button>
                </DialogActions>
              </DialogContent>
            </Dialog>
          </form>
        )}

        {record && paymentDetail.length > 0 && (
          <Box sx={{ mt: 3 }}>
            <Typography variant="h6" sx={{ mb: 1 }}>Historial de pagos</Typography>
            <TableContainer component={Paper}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell><strong>Método</strong></TableCell>
                    <TableCell align="right"><strong>Monto</strong></TableCell>
                    <TableCell><strong>No. Referencia</strong></TableCell>
                    <TableCell><strong>Fecha</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {paymentDetail.map((row) => (
                    <TableRow key={row.id_payment}>
                      <TableCell>{row.payment_method}</TableCell>
                      <TableCell align="right">${Number(row.payment).toFixed(2)}</TableCell>
                      <TableCell>{row.transaction_number ?? '—'}</TableCell>
                      <TableCell>{row.create_date ? row.create_date.substring(0, 10) : ''}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        )}
    </Box>
  );
}

export default IngresoEfectivo;